import React from 'react'

interface FooterProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'className'> {
  children: React.ReactNode
}

export function Footer ({ children, ...props }: FooterProps) {
  return (
    <div
      {...props}
      className='shrink-0 px-6 py-4 border-t border-gray-200'
    >
      {children}
    </div>
  )
}

Footer.displayName = 'Modal.Footer'
